import { render, staticRenderFns } from "./gczrgwsDetails.vue?vue&type=template&id=e48d1788"
import script from "./gczrgwsDetails.vue?vue&type=script&lang=js"
export * from "./gczrgwsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports